/** Clique num aviso não é "clique fora" do drawer/modal.
 *
 * Os avisos (toasts do Sonner e a pilha de acionamentos) ficam POR CIMA do
 * drawer de propósito, para o usuário poder fechá-los. Só que, para o Radix,
 * esse clique acontece fora do conteúdo — e fechava o drawer junto, jogando
 * fora o que a pessoa estava editando.
 */
const CAMADAS_DE_AVISO = "[data-sonner-toaster],[data-sonner-toast],[data-aviso-layer]";

let ultimoCliqueFoiAviso = false;

if (typeof document !== "undefined") {
  document.addEventListener(
    "pointerdown",
    (e) => {
      ultimoCliqueFoiAviso =
        e.target instanceof Element && !!e.target.closest(CAMADAS_DE_AVISO);
    },
    true,
  );
}

const veioDeAviso = (evento) => {
  const alvo = evento?.detail?.originalEvent?.target || evento?.target;
  if (!(alvo instanceof Element)) return false;
  if (alvo.closest(CAMADAS_DE_AVISO)) return true;
  // Fechar o aviso tira o elemento do DOM no mesmo clique: aí o `closest` anda
  // numa árvore solta e não acha nada. Vale o que foi visto no pointerdown.
  return !alvo.isConnected && ultimoCliqueFoiAviso;
};

/** Envolve `onPointerDownOutside`/`onInteractOutside` mantendo o handler da tela. */
export const ignorandoAvisos = (handler) => (evento) => {
  if (veioDeAviso(evento)) {
    evento.preventDefault();
    return;
  }
  handler?.(evento);
};
